<template>
    <b-form-group :label-for="`min`" :label="label" label-cols="3">
        <div class="align-content-center h-100">
            <div class="form-inline mb-1">
                <input
                    v-model="localData.writeOffsMin"
                    v-validate="'decimal:3'"
                    name="writeOffsMin"
                    :class="{
                        'border-danger': errors.has('writeOffsMin')
                    }"
                    type="number"
                    min="0"
                    step="any"
                    class="form-control col-5"
                    aria-describedby="writeOffMin"
                    placeholder="Write off min amount"
                    @input="updateData"
                />
                <span class="col-2 text-center">-</span>
                <input
                    v-model="localData.writeOffsMax"
                    v-validate="maxQuantityValidateRules"
                    name="writeOffsMax"
                    :class="{
                        'border-danger': errors.has('writeOffsMax')
                    }"
                    type="number"
                    min="0"
                    step="any"
                    class="form-control col-5"
                    aria-describedby="writeOffsMax"
                    placeholder="Write off max amount"
                    @input="updateData"
                />
            </div>
        </div>
    </b-form-group>
</template>

<script>
export default {
    props: {
        data: Object
    },
    data() {
        return {
            localData: {
                writeOffsMin: this.data.writeOffsMin,
                writeOffsMax: this.data.writeOffsMax
            }
        };
    },
    methods: {
        updateData() {
            this.$emit("update-data", {
                writeOffsMin: this.localData.writeOffsMin,
                writeOffsMax: this.localData.writeOffsMax
            });
        },
        async validate() {
            const valid = await this.$validator.validateAll();
            return valid;
        }
    },
    computed: {
        label() {
            return `Amount (${this._currency})`;
        },
        maxQuantityValidateRules() {
            const quantity = this.localData.writeOffsMin;
            let validation = `decimal:3`;
            if (quantity == 0) {
                validation += "|min_value:0.001";
            } else if (quantity > 0) {
                validation += `|min_value:${quantity}`;
            }
            return validation;
        }
    }
};
</script>
